/**
 * <promo-video-wrap>
 *
 * Wraps a <video> element and toggles play/pause on click.
 * Adds the `paused` attribute on the host when the video is paused so CSS can
 * show a play-icon overlay via promo-video-wrap[paused]::after.
 */
class PromoVideoWrap extends HTMLElement {
  connectedCallback() {
    this._video = this.querySelector('video');
    if (!this._video) return;
    this._video.addEventListener('click', () => this._toggle());
  }

  _toggle() {
    if (this._video.paused) {
      this._video.play();
      this.removeAttribute('paused');
    } else {
      this._video.pause();
      this.setAttribute('paused', '');
    }
  }
}

/**
 * <promo-media-picker>
 *
 * Reads breakpoint on connect, picks the matching <template data-promo-media="desktop|mobile">
 * child, and appends its content into itself.  Template content is inert until cloned so
 * neither video nor image assets are fetched for the hidden breakpoint.
 */
class PromoMediaPicker extends HTMLElement {
  connectedCallback() {
    const key = window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
    const tmpl = this.querySelector(`template[data-promo-media="${key}"]`);
    if (!tmpl) return;

    this.append(tmpl.content.cloneNode(true));

    const video = this.querySelector('video');
    if (video) video.play().catch(() => {});
  }
}

customElements.define('promo-video-wrap', PromoVideoWrap);
customElements.define('promo-media-picker', PromoMediaPicker);
